<h1 mat-dialog-title>{{ 'properties.dialog.assignTagger.title' | translate }}</h1>

<mat-dialog-content class="mb-3 content">
  <div class="mt-2 mb-3">
    {{ 'properties.dialog.assignTagger.description' | translate}}
  </div>
  <form [formGroup]="form" class="mb-5">
    <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
  </form>
</mat-dialog-content>

<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <a mat-button (click)="onClose()" mat-raised-button mat-default
      class="ml-3">{{ 'common.cta.close' | translate }}</a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <mat-spinner-button (click)="onFormSubmit(model)" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div> <!-- /.col -->
</div> <!-- /.row -->